import React, { memo } from 'react'
import { Button, Modal, Icon } from '../index'
import { util } from '../../../util'

/**
 *
 * @param message
 * @param toggleModal
 * @returns {*}
 * @constructor
 */
const GenericAlertModal = ({ message, toggleModal, size = 'xs', heading, btnText = 'OK' }) => {
    const header = (
        <div className={'generic-alert-modal__heading'}>
            <Icon color={'danger'} size={'lg'} renderIcon={util.ReportProblemIcon} />
            <p>{heading}</p>
        </div>
    )

    const content = <div className={'generic-alert-modal__content'}>{message}</div>

    const actions = (
        <div className={'generic-alert-modal__actions'}>
            <Button color={'primary'} size={'md'} onClick={toggleModal}>
                {btnText}
            </Button>
        </div>
    )

    return <Modal header={header} content={content} actions={actions} size={size} />
}

export default memo(GenericAlertModal)
